import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@fontsource-variable/inter'
// Cursiva verdadera: el paquete base solo trae la cara normal y el navegador sintetiza una oblicua.
import '@fontsource-variable/inter/wght-italic.css'
import './assets/tailwind.css'

const app = createApp(App)
app.use(router)
app.mount('#app')